import * as React from "react";
import { Link } from "gatsby";
import Seo from "../components/seo";
import { Container, Row, Col } from "react-bootstrap";
import { InternetOfThingsIotApplicationsMeta } from "../data/metaData";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../components/layout/layout";
import LazyLoad from "react-lazy-load";

import { Animations } from "../components/animations";
import Icon1 from "../animations/web-application-development/experience_developer.json";
import Icon2 from "../animations/web-application-development/cutting_edge_technology.json";
import Icon3 from "../animations/web-application-development/agile_practices.json";
import Icon4 from "../animations/mobile-application-development/Transparency-Communication.json";
import Icon5 from "../animations/web-application-development/high_quality_solution.json";
import Icon6 from "../animations/web-application-development/customer_experience.json";
import Faqs from "../components/faqs";

const ClientsTestimonial = React.lazy(() => import('../components/clients-testimonial'))
const CaseStudy = React.lazy(() => import('../components/case-study'))
const BlogList = React.lazy(() => import('../components/blog/blog-list'))
const WhyChooseFacts = React.lazy(() => import('../components/why-choose-facts'))

export const Head = () => (
  <Seo
    title={InternetOfThingsIotApplicationsMeta.metaTitle}
    description={InternetOfThingsIotApplicationsMeta.metaDescription}
    ogImage={InternetOfThingsIotApplicationsMeta.ogImage}
    twitterImage={InternetOfThingsIotApplicationsMeta.twitterImage}
  />
)

const InternetOfThingsIotApplicationsPage = () => {

  const CTABgDark = '../images/cta-bg-dark1.png'

  const excellence = [
    {
      title: "IoT Consulting",
      des: "You get sound and professional advice from us to build the best IoT solutions. Our experienced professionals have huge expertise in building effective digital strategies that shape your dreams into realities."
    },
    {
      title: "IoT App Development",
      des: "Being a reliable application development company, we use the latest digital technologies to build scalable IoT applications to make your business stand out from the competition."
    },
    {
      title: "IoT Wearable App Development",
      des: "We are committed to create highly robust and scalable mobile apps for wearable devices such as fitness trackers, smartwatches, smart jewelry, head-mounted displays, and more."
    },
    {
      title: "IoT Integration",
      des: "If you are looking for an IoT app development company to integrate IoT apps with cloud platforms, Big Data, or API portals, we are there to help you."
    },
    {
      title: "IoT Testing and Maintenance",
      des: "Using the latest quality assurance tools and strategies, we offer the best testing and support services for IoT devices. You can expect bug-free software development services from Peerbits."
    },
    {
      title: "IoT firmware testing",
      des: "We can help you build firmware for a variety of devices by developing embedded apps, firmware, and middleware supporting various types of scenarios across multiple industry verticals."
    }
  ]

  const iotsection = [
    {
      iconclass: "icon-1",
      title: "Industrial IOT (IIoT)",
      des: "IoT-based software development to keep track of industrial process, equipment, and assets - making operations more efficient and keeping their equipment in good shape.",
      list: [
        {
          list1: "Real-time monitoring"
        },
        {
          list1: "Predictive maintenance alerts"
        },
        {
          list1: "Asset tracking and utilization analysis"
        },
        {
          list1: "Customizable dashboard and report"
        },
        {
          list1: "Security features"
        },
      ]
    },
    {
      iconclass: "icon-2",
      title: "Asset Tracking",
      des: "Custom software development for physical assets tracking - streamlining fleet management by automating the operations.",
      list: [
        {
          list1: "Real-time asset location tracking"
        },
        {
          list1: "History tracking of fleet and asset"
        },
        {
          list1: "Alert when an asset enters or leaves a location"
        },
        {
          list1: "Integration with ERP and CRM"
        },
        {
          list1: "Customizable reports"
        },
        {
          list1: "Access the asset tracking from mobile devices"
        },
        {
          list1: "Security measures against unauthorized access"
        },
      ]
    },
    {
      iconclass: "icon-3",
      title: "Building automation",
      des: "Automation of buildings like residential buildings, hospitality infrastructure, or commercial spaces - making building intelligent and shaping the future.",
      list: [
        {
          list1: "Enhanced occupant comfort"
        },
        {
          list1: "Improved security"
        },
        {
          list1: "Energy-efficiency"
        },
        {
          list1: "Time-efficiency"
        },
        {
          list1: "Performance documentation"
        },
        {
          list1: "Improved equipment life cycle"
        },
        {
          list1: " More comfortable lifestyle"
        },
      ]
    },
    {
      iconclass: "icon-4",
      title: "Healthcare IoT solutions",
      des: "Custom healthcare IoT solutions to deliver personalized care, empower patient care, care teams, and improve opperational outcomes.",
      list: [
        {
          list1: "Real-time data collection"
        },
        {
          list1: "Patient remote monitoring"
        },
        {
          list1: "Customizable dashboards and reports"
        },
        {
          list1: "Security measure to protect patient data"
        },
        {
          list1: "Scalable to add new devices and sensors"
        },
      ]
    },
    {
      iconclass: "icon-5",
      title: "Foodtech IOT Solution",
      des: "IoT-powered tailored software to improve various aspects of the food industry, from production and processing to distribution and consumption.",
      list: [
        {
          list1: "Real-time tracking and traceability"
        },
        {
          list1: "Quality control"
        },
        {
          list1: "Predictive analysis"
        },
        {
          list1: "Food waste reduction"
        },
        {
          list1: "Integrate with third party systems"
        },
        {
          list1: "Increase sustainability"
        },
      ]
    },
    {
      iconclass: "icon-6",
      title: "Fitness IOT",
      des: "Larger connected ecosystem for tracking fitness activities across devices and platforms",
      list: [
        {
          list1: "Improved tracking and monitoring"
        },
        {
          list1: "Personalized coaching and guidance"
        },
        {
          list1: "Increased motivation"
        },
        {
          list1: "Progess tracking"
        },
        {
          list1: "Customizable dashboards and reports"
        },
      ]
    }
  ]

  const businesssmart = [
    {
      title: "Programming Languages",
      list: [
        {
          list1: "C/C++"
        },
        {
          list1: "Python"
        },
        {
          list1: "Ruby"
        },
        {
          list1: "JavaScript"
        },
      ]
    },
    {
      title: "Frameworks",
      list: [
        {
          list1: "Node.js"
        },
        {
          list1: "IoT.js"
        },
        {
          list1: "Device.js"
        },
        {
          list1: "Eclipse IoT"
        },
        {
          list1: "AngularJS"
        },
      ]
    },
    {
      title: "Platforms",
      keyname: "platform",
      list: [
        {
          list1: "Amazon Web Services IoT"
        },
        {
          list1: "Microsoft Azure IoT"
        },
        {
          list1: "Google Cloud IoT"
        }
      ]
    },
    {
      title: "Communication Protocols",
      list: [
        {
          list1: "Bluetooth"
        },
        {
          list1: "BLE"
        },
        {
          list1: "Cellular"
        },
        {
          list1: "NFC"
        },
        {
          list1: "RFID"
        },
        {
          list1: "Z-Wave"
        },
        {
          list1: "USB"
        },
        {
          list1: "IPv6"
        },
        {
          list1: "CoAP"
        },
        {
          list1: "AMQP"
        },
        {
          list1: "MQTT"
        },
        {
          list1: "HTTP/HTTPS"
        },
        {
          list1: "Wi-Fi"
        },
        {
          list1: "ZigBee"
        },
        {
          list1: "BACnet"
        },
        {
          list1: "ModBus"
        },
        {
          list1: "CAM"
        },
      ]
    },
    {
      title: "Hardware",
      list: [
        {
          list1: "NXP i.MX8"
        },
        {
          list1: "Advantech"
        },
        {
          list1: "Xilinx"
        },
        {
          list1: "Asus"
        },
        {
          list1: "Sphere Guardian"
        },
        {
          list1: "Beacons"
        },
        {
          list1: "Microcontrollers"
        },
        {
          list1: "FPGA controllers and many more"
        },
      ]
    },
    {
      title: "Sensor Technology",
      list: [
        {
          list1: "Omega"
        },
        {
          list1: "Analog"
        },
        {
          list1: "ADV"
        },
        {
          list1: "RF433"
        },
        {
          keyname: "xl-12",
          list1: "various analog and digital sensors compatible with R&D prototyping with Arduino and Raspberry Pi and custom sensor R&D"
        },
      ]
    },
    {
      title: "Third-party APIs",
      list: [
        {
          list1: "Apple HomeKit"
        },
        {
          list1: "Android Things"
        },
        {
          list1: "Google Assistant"
        },
        {
          list1: "Google Home"
        },
        {
          list1: "Google Vision"
        },
        {
          list1: "MI Light"
        },
        {
          list1: "Cortana"
        },
        {
          list1: "Alexa Voice Service"
        },
        {
          list1: "Philips Hue"
        },
      ]
    },
  ]

  const choosedata = [
    {
      icon: Icon1,
      title: "Experienced Team",
      des: "We are backed up with a team of experienced and talented IoT app developers who leave no stone unturned to provide the best services to our clients worldwide."
    },
    {
      icon: Icon2,
      title: "Latest Technologies",
      des: "Our team uses the latest tools and technologies to deliver future-ready IoT app development solutions for your business."
    },
    {
      icon: Icon3,
      title: "User-friendly interfaces",
      des: "At Peerbits, we are dedicated to design user-friendly interfaces to make IoT applications easier to use."
    },
    {
      icon: Icon4,
      title: "Support and Maintenance",
      des: "You get round-the-clock support and maintenance from us. We ensure that your IoT solutions work well all the time, without any glitches."
    },
    {
      icon: Icon5,
      title: "Robust and scalable solutions",
      des: "When you hire us for IoT application development services, you get scalable and robust solutions from us. You can scale up the apps as per the requirements."
    },
    {
      icon: Icon6,
      title: "Confidentiality",
      des: "We maintain complete confidentiality of your project ideas by signing NDAs. We do not share any information with third parties without your consent."
    },
  ]
  const service = [
    {
      title: "Finance",
      iconclass: "finance",
      des: "Mobile wallet apps,FinTech SaaS platform, Neobank apps, and other financial app development.",
      secdes: "Our FinTech professionals blend their technical prowess with financial expertise and create an advanced fintech solution that smoothens the transactional process, and help gain a massive market share.",
      url: "/financial-software-development.html"
    },
    {
      title: "Healthcare",
      iconclass: "healthcare",
      des: "Telemedicine app, Healthcare SaaS platform, mHealth apps, & other healthcare software development.",
      secdes: "Our custom healthcare software developers create software that compiles with healthcare regulations aiming to improve patient outcomes, provide remote care and automate medical workflows.",
      url: "/healthcare-software-development.html"

    },
    {
      title: "Logistics",
      iconclass: "logistics",
      des: "Fleet management system, Warehouse management system, Yard management system and other logistics software development.",
      secdes: "Our logistics software development experts apply a customized approach and help you create a scalable system that allows you to realize the full potential of your logistics & transportation operations.",
      url: "/logistics-software-development.html"

    },
  ]
  const accordian = [
    {
      title: "How long does it take to build an IoT application?",
      des: "The timeline to build an Internet of Things (IoT) application depends on several factors such as complexity of the project, features required, and more. We use Agile methodology to ensure faster delivery of the project."
    },
    {
      title: "What type of IoT apps does Peerbits build?",
      des: "We build a wide range of IoT solutions for healthcare, fintech, and logistics industries."
    },
    {
      title: "How will I get an idea about the progress of the project?",
      des: "Our team sends regular updates about the progress of the project so that you can get an idea about what’s going on. You can also suggest the changes in design or features of the app while it’s being developed."
    },
    {
      title: "Would there be any hidden charges?",
      des: "No. We discuss the prices with the clients before we start working on your project."
    },
    {
      title: "Do you provide after-sales support and assistance?",
      des: "Yes. We provide exceptional support and assistance to the clients right from project conceptualization to successful delivery of the project. We also provide after-sales support to our clients."
    }
  ]
  return (
    <>
      <Layout>
        <section className="section  background-pattern min-vh-100 d-flex align-items-center">
          <Container className="py-5 mt-lg-5">
            <div className="max-width-950 text-center mx-auto">
              <h1 className="sub-title mb-3">IoT Development Services</h1>
              <h2 className="mb-4 h1">
                <span className="text-primary">Connecting</span> humans with technology
              </h2>
              <p className="lead">
                <span className="">Revolutionizing and modernizing businesses through IoT app development solutions that promote innovation for various industries across the globe. </span>
              </p>
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                Talk to Us
              </Link>
            </div>
          </Container>
        </section>

        <section className="section bg-light">
          <Container className="py-5">
            <Row className="g-5">
              <Col lg={6}>
                <div className="sticky-section">
                  <h2 className="sub-title mb-3">IoT App Development Services</h2>
                  <h3 className="mb-4 h2">
                    Our end-to-end IoT software development <span className="text-primary">service offerings</span>
                  </h3>
                  <p className="lead">We transform your business with our cutting-edge IoT software development services. </p>
                  <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-3">
                    Talk to expert
                  </Link>
                </div>
              </Col>
              <Col lg={6}>
                <Row className="g-4" xs={1} md={1} lg={1}>
                  {
                    excellence.map((item, index) => (
                      <Col key={index}>
                        <div className="dark-box-2 border">
                          <p className="text-primary mb-3">
                            <i className="zmdi zmdi-dot-circle zmdi-hc-fw font-size-24"></i>
                          </p>
                          <h3 className="h4 mb-3">{item.title}</h3>
                          <p className="mb-0">{item.des}</p>
                          {
                            item.url ?
                              <Link to={item.url} className="btn btn-link px-0">
                                <span>Learn more</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                              </Link> :
                              null
                          }
                        </div>
                      </Col>
                    ))
                  }
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Accelerate with <span className="text-primary">IoT Application Development</span> solutions
              </h2>
              <p className="max-width-950 lead">To enhance productivity and maintain a high level of scalability, speed, and security, our internet of things application development solutions are ideal</p>
            </div>
            <Row className="g-4" xs={1} md={2} lg={2}>
              {
                iotsection.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-1 left-icon-box equal-height">
                      <i className={`iot-applications-sprite-icon ${item.iconclass} icon-size-70 mb-4`}></i>
                      <h3 className="h4 mb-3">{item.title}</h3>
                      <p className="mb-4">{item.des}</p>
                      <ul className="bullet-list fw-medium">
                        {
                          item?.list?.map((item, index) => (
                            <li key={index}>{item.list1}</li>
                          ))
                        }
                      </ul>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>

        <section className="section bg-light">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Tech we use to make your <span className="text-primary">business smart</span>
              </h2>
              <p className="max-width-950 lead">Use a reliable tech stack to create a reliable foundation for your business.</p>
            </div>
            <Row className="g-4" xs={1} md={2} lg={1}>
              {
                businesssmart.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-2 equal-height mb-4 d-flex align-items-start align-items-lg-center">
                      <Row className="g-4 g-lg-5 align-items-center flex-fill">
                        <Col lg={3} className="text-start text-lg-center">
                          <h3 className="font-size-24">{item.title}</h3>
                        </Col>
                        <Col lg={9} className="border-start border-color-secondary">
                          <Row as="ul" xs={1} sm={2} md={1} lg={3} xl={item.keyname === "platform" ? 3 : 4} className="bullet-list ps-0 ps-lg-4">
                            {
                              item?.list?.map((item, index) => (
                                <li
                                  className={`${item.keyname === "xl-12" ? "col col-xl-12" : "col"}`}
                                  key={index}>{item.list1}</li>
                              ))
                            }
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>


        <section className="section bg-black section-background">
          <Container className="py-5">
            <div className="text-center max-width-1000 mx-auto">
              <h2 className="heading mb-4 text-white">
                Partner with us for exceptional <span className="text-primary">IoT app development</span>
              </h2>
              <p className="lead text-white-75">Transform your business with cutting-edge IoT solutions. Let’s innovate together!</p>
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                Get in Touch
              </Link>
            </div>
          </Container>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={CTABgDark}
              alt='Home banner pattren'
            />
          </LazyLoad>
        </section>

        <CaseStudy
          category='IoT'
          title="Our <span class='text-primary'>work</span> speaks for itself."
          description='We do it right when no one is looking. Discover how we made our client"s project a success story.'
          sectionClass="bg-light"
        />

        <section className="section ">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Why consider Peerbits for<br /><span className="text-primary">IoT App Development</span> services?
              </h2>
              <p className="max-width-950 lead">Being a leading IoT app development company, we have worked on a wide range of projects for multiple industries. Some of the common reasons to choose us are:</p>
            </div>
            <WhyChooseFacts />
            <Row className="g-4 hover-box" xs={1} md={2} lg={3}>
              {
                choosedata.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-2 center-icon-box equal-height">
                      <div className="icon icon-size-70 mb-4">
                        <LazyLoad offset={150}>
                          <Animations animation={item.icon} />
                        </LazyLoad>
                      </div>
                      <h3 className="h4 mb-3">{item.title}</h3>
                      <p className="">{item.des}</p>
                    </div>
                  </Col>
                ))
              }
            </Row>
            <div className="pt-5 mt-4 text-center">
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline">
                Build intelligent IoT solutions
              </Link>
            </div>
          </Container>
        </section>

        <section className="section bg-light">
          <Container className="py-5">
            <div className="mb-5 pb-1 max-width-950">
              <h2 className="mb-4">
                <span className="text-primary">Industries</span> we focus
              </h2>
              <p className="max-width-950 lead">We deliver industry-focused IoT application to produce value and overcome unique business challenges.</p>
            </div>
            <Row as="ul" xs={1} md={2} lg={3} className="list-unstyled industries-flip-hover-box g-4">
              {
                service.map((item, index) => (
                  <Col as="li" key={index}>
                    <Link to={item.url} className="flip-card dark-box-2 p-0 rounded-3 equal-height">
                      <div className="flip-card-inner">
                        <div className="flip-card-front p-4">
                          <i className={`mobile-application-sprite-icon ${item.iconclass} icon-size-70 mb-3`}></i>
                          <h3 className="h4 mb-3">{item.title}</h3>
                          <p className="text mb-0">{item.des}</p>
                        </div>
                        <div className="flip-card-back p-4">
                          <h3 className="h4 mb-3">{item.title}</h3>
                          <p>{item.secdes}</p>
                          <span className="btn btn-link px-0">
                            <span>Explore our domain expertise  </span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                          </span>
                        </div>
                      </div>
                    </Link>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>

        <ClientsTestimonial
          title="Our esteemed <span class='text-primary'>client's testimonial</span>"
          description="Our esteemed global clients praised us loud for delivering their expectations and success."
          sectionClass="bg-white"
        />
        <Faqs sectionClass="bg-light" accordian={accordian} />
        <BlogList
          category='IoT'
          title="Insightful <span class='text-primary'>blogs</span>"
          description="Explore our super insightful technical blogs and stay updated with the present and future trends."
          sectionClass="bg-white"
        />

      </Layout>
    </>
  );
};

export default InternetOfThingsIotApplicationsPage;
